import Navbar from '@/components/feature/Navbar';
import AnnouncementPopup from '@/components/feature/AnnouncementPopup';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import BlogSection from './components/BlogSection';
import ProductShowcase from './components/ProductShowcase';
import RecommendedProducts from './components/RecommendedProducts';
import NewProducts from './components/NewProducts';
import HowItWorks from './components/HowItWorks';
import SellerCta from './components/SellerCta';
import Testimonials from './components/Testimonials';
import Newsletter from './components/Newsletter';

export default function Home() {
  return (
    <div className="bg-background-50 text-foreground-100">
      <AnnouncementPopup />
      <Navbar />
      <main>
        <Hero />
        <BlogSection />
        <ProductShowcase />
        <RecommendedProducts />
        <NewProducts />
        <HowItWorks />
        <SellerCta />
        <Testimonials />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
}